import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import AppStyles from '../styles/AppStyles';

const ErrorState = ({ 
  message = null,
  imageSrc = "/error.png",
  imageWidth = 400,
  showErrorDetails = false,
  error = null 
}) => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        background: 'transparent',
        minHeight: '100vh',
        padding: AppStyles.spacing.component.padding,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        textAlign: 'center',
        mt: -6,
      }}
    >
      <Box
        component="img"
        src={imageSrc}
        alt={t('common.error')}
        sx={{
          width: imageWidth,
          height: 'auto',
          mb: 4,
          maxWidth: '100%',
        }}
      />
      <Typography
        variant="h4"
        sx={{
          color: AppStyles.colors.primary.dark,
          fontWeight: AppStyles.typography.fontWeight.semibold,
          letterSpacing: '0.01em',
        }}
      >
        {message || t('common.errorMessage')}
      </Typography>
      {showErrorDetails && error && (
        <Typography
          variant="body1"
          sx={{
            color: AppStyles.colors.text.secondary,
            fontWeight: AppStyles.typography.fontWeight.regular,
            mt: 2,
          }}
        >
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default ErrorState;
